import { render, staticRenderFns } from "./RowBlock.vue?vue&type=template&id=3fab76c2&scoped=true&"
import script from "./RowBlock.vue?vue&type=script&lang=js&"
export * from "./RowBlock.vue?vue&type=script&lang=js&"
import style0 from "./RowBlock.vue?vue&type=style&index=0&id=3fab76c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fab76c2",
  null
  
)

export default component.exports